import api from "./api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async (additionalHeaders = {}) => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
      ...additionalHeaders,
    },
  };
};

//Product management by vendor

export const createProductByVendor = async (formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.post("/createProduct", formData, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductByVendor = async (productId, formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.put(
      `/updateProduct/${productId}`,
      formData,
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductsByVendor = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllProducts", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInventoryByVendor = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getInventoryByVendor", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductStock = async (productId, stock) => {
  try {
    const config = await getAuthConfig();
    const response = await api.patch(
      "/updateProductStock",
      { productId, stock },
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// product management by admin
export const createProductByAdmin = async (formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.post("/createProductByadmin", formData, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductByAdmin = async (productId, formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.put(
      `/updateProduct/${productId}`,
      formData,
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductsByAdmin = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllProductsByAdmin", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const reviewProduct = async (productId, status) => {
  const config = await getAuthConfig();
  const response = await api.patch(
    `/reviewProductAdmin/${productId}`,
    { status },
    config
  );
  return response;
};
